import * as currentState from '../global-state/state';

export class ChartService {

    public update(canvasElement: string) {
        currentState.chart[canvasElement].chart_object.update();
    }

    public render(canvasElement: string) {
        currentState.chart[canvasElement].chart_object.render();
    }

    public getChartObject(canvasElement: string) {
        return currentState.chart[canvasElement].chart_object;
    }

    public getChartType(canvasElement: string) {
        return currentState.chart[canvasElement].chart_type;
    }

    public getChartOptions(canvasElement: string) {
        return currentState.chart[canvasElement].chart_options;
    }

    public getChartData(canvasElement: string) {
        return currentState.chart[canvasElement].chart_data;
    }
}



// WEBPACK FOOTER //
// ./src/common/charts/services/chart.service.ts